/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { FormControl, FormGroup } from "@material-ui/core";
import TaskItemCheckbox from "./TaskItemCheckbox";
import { Search } from "lucide-react";
import { Input } from "../../../../components/ui/input";

const TaskLists = (props) => {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [taskList, setTaskList] = React.useState([]);

  useEffect(() => {
    setTaskList(props.taskList);
  }, [props.taskList]);

  // Enhanced search filtering using useMemo for efficiency
  // It checks both task titles and their parent category names
  const filterdSearchList = React.useMemo(() => {
    if (!taskList) return [];

    const searchLow = searchTerm.toLowerCase().trim();
    if (!searchLow) return taskList;

    return taskList.filter((titem) => {
      const parent = props.serviceTypes?.find((st) => st.id === titem.parentCategoryId);
      const parentTitle = parent ? parent?.title : "";

      return (
        String(titem?.title).toLowerCase().includes(searchLow) ||
        parentTitle.toLowerCase().includes(searchLow)
      );
    });
  }, [taskList, searchTerm, props.serviceTypes]);

  /**
   * Groups filtered tasks by their parent category for structured display
   * Optimized to run only when the filtered list or categories change
   */
  const groupedTasks = React.useMemo(() => {
    if (!filterdSearchList || filterdSearchList.length === 0) return {};

    return filterdSearchList.reduce((acc, task) => {
      const parent = props.serviceTypes?.find((st) => st.id === task.parentCategoryId);
      const parentTitle = parent ? parent?.title : "Others";

      if (!acc[parentTitle]) {
        acc[parentTitle] = [];
      }
      acc[parentTitle].push(task);
      return acc;
    }, {});
  }, [filterdSearchList, props.serviceTypes]);

  return (
    <div>
      <div className="stepSectionTitle color-black d-flex flex-center mv-0">
        {props?.search === true && (
          <div className="mb-4 flex items-center w-100">
            <Search className="w-4 h-4 mr-8 text-gray-400" />
            <Input
              name="searchTask"
              id="searchTask"
              onChange={(e) => setSearchTerm(e.target.value)}
              value={searchTerm}
              placeholder="Search tasks or industries..."
              disabled={props?.disabled}
            />
          </div>
        )}
      </div>

      {Object.keys(groupedTasks).length > 0 ? (
        <div className={`stepSectionContent pl-15 scrollable `}>
          <FormControl component="div" className={"checkboxfieldwrap w-100"}>
            {Object.entries(groupedTasks).map(([parentTitle, tasks], groupIndex) => (
              <div
                key={`${parentTitle}-${groupIndex}`}
                style={{
                  marginTop: groupIndex === 0 ? "10px" : "0",
                  marginBottom: groupIndex < Object.keys(groupedTasks).length - 1 ? "32px" : "0",
                  width: "100%"
                }}
              >
                {/* Industry Header Styled with Conditional Colors for Light/Dark Mode */}
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "800",
                    textTransform: "uppercase",
                    letterSpacing: "0.075em",
                    marginBottom: "16px",
                    paddingBottom: "4px",
                    borderBottom: "1px solid rgba(16, 185, 129, 0.1)"
                  }}
                  className="text-gray-600 dark:text-[#10b981]"
                >
                  {parentTitle}
                </div>

                <div className={"checkboxGroupwrap column-2"}>
                  <FormGroup row>
                    {tasks?.map((TaskItem, index) => (
                      <TaskItemCheckbox
                        key={TaskItem?.taskId ?? TaskItem?.id ?? `task-${index}`}
                        index={index}
                        Task={TaskItem}
                        selected={props?.checkselected(TaskItem?.taskId ?? TaskItem?.id)}
                        handleTasksCheckChange={props?.handleTasksCheckChange}
                        removeTask={props?.removeTask}
                        onEditTask={props?.onEditTask}
                        shifttitle={props.shifttitle}
                        disabled={props?.disabled}
                      />
                    ))}
                  </FormGroup>
                </div>
              </div>
            ))}
          </FormControl>
        </div>
      ) : (
        <div className="text-center py-10 text-gray-400">
          No matching tasks found.
        </div>
      )}
    </div>
  );
};

export default TaskLists;
